
import {
  defineComponent, inject, onMounted, Ref, ref,
} from 'vue';

export default defineComponent({
  emits: ['hide'],
  props: {
    hideBottomDecoration: { type: Boolean, default: false },
    hideTopDecoration: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const navigation: Ref<HTMLElement | null> = ref(null);
    const isMediaSettingsPopUp = inject('isMediaSettingsPopUp');

    let navigationY = 0;
    let isHolding = false;

    function parsePxToNumber(pxValue: string): number {
      return Number(pxValue.split('px')[0]);
    }

    function elementDraged() { // event: MouseEvent | TouchEvent
      if (props.hideTopDecoration) return;
      isHolding = true;
    }

    function mouseMove(event: MouseEvent) {
      if (props.hideTopDecoration) return;
      if (isHolding) {
        const movementY = navigationY - event.clientY;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        navigation.value!.style.top = `${navigationY - movementY}px`;
      }
    }

    function elementDroped() { // event: MouseEvent | TouchEvent
      if (props.hideTopDecoration) return;
      isHolding = false;
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (parsePxToNumber(navigation.value!.style.top) >= navigationY + 200) {
        emit('hide');
      } else {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        navigation.value!.style.top = '';
      }
    }

    function touchMove(event: TouchEvent) {
      if (props.hideTopDecoration) return;
      if (isHolding) {
        const movementY = navigationY - event.changedTouches[0].clientY;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        navigation.value!.style.top = `${navigationY - movementY}px`;
      }
    }

    onMounted(() => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      navigationY = navigation.value!.offsetTop;
    });

    return {
      navigation,
      elementDraged,
      mouseMove,
      touchMove,
      elementDroped,
      emit,
      isMediaSettingsPopUp,
    };
  },
});
